import gql from './index';

interface FindResponse<Records> {
  table: Records[];
  aggregate: {
    aggregate: {
      count: number;
    },
  };
}

export default <ReturnFields>(
  tableName: string,
  returnFields: string,
) => gql<FindResponse<ReturnFields>>(`
  query ${tableName}(
    $limit: Int!
    $offset: Int!
    $orderBy: [${tableName}_order_by!]
    $where: ${tableName}_bool_exp
  ) {
    table: ${tableName}(
      limit: $limit
      offset: $offset
      order_by: $orderBy
      where: $where
    ) {
      ${returnFields}
    }
    aggregate: ${tableName}_aggregate(
      where: $where
    ) {
      aggregate {
        count
      }
    }
  }
`);

export interface IPage {
  number: number;
  query?: {
    [field: string]: any;
  };
  recordCount: number;
  size: number;
}

export interface PaginationRequest {
  page: IPage;
}
